// Minimal English + Hindi dictionary for UI copy.
import { useApp } from "./appContext";

const DICT = {
  dashboard: { en: "Dashboard", hi: "डैशबोर्ड" },
  favorites: { en: "Favorites", hi: "पसंदीदा" },
  history: { en: "History", hi: "इतिहास" },
  search_placeholder: { en: "Search calculators… (⌘K)", hi: "कैलकुलेटर खोजें… (⌘K)" },
  open: { en: "Open", hi: "खोलें" },
  results: { en: "Results", hi: "परिणाम" },
  reset: { en: "Reset", hi: "रीसेट" },
  copy: { en: "Copy", hi: "कॉपी" },
  share: { en: "Share", hi: "शेयर" },
  print: { en: "Print", hi: "प्रिंट" },
  state: { en: "State", hi: "राज्य" },
  language: { en: "भाषा / Language", hi: "भाषा / Language" },
  choose_state: { en: "Choose your state", hi: "अपना राज्य चुनें" },
  choose_state_desc: {
    en: "We tailor Bigha, Katha and stamp duty rates to your state.",
    hi: "हम आपके राज्य के अनुसार बीघा, कट्ठा और स्टाम्प शुल्क दिखाते हैं।",
  },
  continue: { en: "Continue", hi: "जारी रखें" },
  popular: { en: "Popular tools", hi: "लोकप्रिय टूल" },
  all_calculators: { en: "All calculators", hi: "सभी कैलकुलेटर" },
  categories: { en: "Categories", hi: "श्रेणियाँ" },
  cat_land: { en: "Land Measurement", hi: "भूमि मापन" },
  cat_registry: { en: "Registry & Stamp Duty", hi: "रजिस्ट्री और स्टाम्प" },
  cat_construction: { en: "Construction", hi: "निर्माण" },
  cat_finance: { en: "Finance", hi: "वित्त" },
  cat_agriculture: { en: "Agriculture", hi: "कृषि" },
  cat_investment: { en: "Property Investment", hi: "प्रॉपर्टी निवेश" },
  hero_title: { en: "India's most comprehensive land calculator suite.", hi: "भारत का सबसे व्यापक भूमि कैलकुलेटर संग्रह।" },
  hero_sub: {
    en: "State-aware Bigha, Katha, Kanal, Ground, Ankanam. Stamp duty, EMI, warehouse, construction & agri tools for every Indian state.",
    hi: "राज्य-आधारित बीघा, कट्ठा, कनाल, ग्राउंड, अंकणम। हर भारतीय राज्य के लिए स्टाम्प, EMI, गोदाम, निर्माण और कृषि टूल।",
  },
  how_it_works: { en: "How it works", hi: "यह कैसे काम करता है" },
  faq: { en: "Frequently asked", hi: "अक्सर पूछे जाने वाले" },
  related_tools: { en: "Related tools", hi: "संबंधित टूल" },
  ad_placeholder: { en: "Advertisement", hi: "विज्ञापन" },
};

export function useT() {
  const { lang } = useApp();
  const t = (key, fallback) => (DICT[key]?.[lang] ?? DICT[key]?.en ?? fallback ?? key);
  return t;
}
